module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section03_04_beach-photo-58f3895944a576df737d255488728b69.jpg";